import React from 'react';

interface ContainerProps {
  title?: string;
  children?: React.ReactNode;
  bottomSpace?: boolean;
}

function Container({ title, children, bottomSpace }: ContainerProps) {
  return (
    <div
      className={`block w-full my-6 bg-silver rounded-xl border border-borders overflow-hidden ${
        bottomSpace ? 'mb-28' : ''
      }`}
    >
      <h5 className="p-6 border-b border-borders font-medium text-base text-primary-100">
        {title}
      </h5>
      <div className="block w-full bg-white">{children}</div>
    </div>
  );
}

export default Container;
